let __customizationMap = {};

export default {
    setCustomization: (pCustomMap) => {
        __customizationMap = pCustomMap;
    },

    getCustomization: (pBizInstitution, pZjm) => {
        if (!__customizationMap[pBizInstitution]) {
            return null;
        }

        if (!__customizationMap[pBizInstitution][pZjm]) {
            return null;
        }

        return __customizationMap[pBizInstitution][pZjm];
    },

    clear: () => {
        __customizationMap = {};
    }
};
